<template>
	<div id='store-out'>
		<template v-if="showPage==1">
			<div style="width:100%;heigh:100%;">
				<el-card class="table_searchbar">
					<el-row :gutter="20">
						<el-col :span='5'>
							<div @keydown.enter="btnSearch()" class="span_flex">
								<span class="title">出库单号：</span>
								<el-select size="small" style="max-width:180px;" v-model="searchForm.stockOutId" placeholder="出库单号" @visible-change="closeSelect($event)"  remote :remote-method="(query)=>{this.remoteMethod(query)}" :loading="loading" filterable clearable>
									<el-option v-for="item in stockOutCodeList" :key="item.stockOutId" :label="item.stockOutCode" :value="item.stockOutId"></el-option>
								</el-select>
							</div>
						</el-col>
						<el-col :span="5">
							<div class="" @keydown.enter="btnSearch()">
								<span class="title">出库类型：</span>
								<el-select size="small" style="max-width:180px;" v-model="searchForm.stockOutType" placeholder="出库类型" clearable>
									<el-option v-for="item in stockOutTypeOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</div>
						</el-col>
						<el-col :span="5">
							<div class="">
								<span class="title">状态：</span>
								<el-select size="small" style="max-width:180px;" v-model="searchForm.auditStatus" placeholder="审核状态" clearable>
									<el-option v-for="item in statusOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</div>
						</el-col>
						<el-col :span="5">
							<div class="" @keydown.enter="btnSearch()">
								<span class="title">申请人：</span>
								<el-select size="small" style="max-width:180px;" v-model="searchForm.applicantId" placeholder="申请人" filterable clearable>
									<el-option v-for="item in userList" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</div>
						</el-col>
						<el-col :span="4">
							<div style="text-align:right">
								<a style="margin-right: 12px;cursor: pointer;font-size: 12px;" @click="toggleShowMore">
                                    {{ showMore ? '收起' : '展开' }}
                                    <i :class="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
                                </a>
								<el-button size="mini" icon="el-icon-search" type="primary" @click="btnSearch()">查询</el-button>
								<el-button size="mini" icon="el-icon-refresh" @click='clearSearch'>重置</el-button>
							</div>
						</el-col>
					</el-row>
					<el-collapse-transition>
                        <div v-show="showMore">
							<el-row :gutter="20">
								<el-col :span="10">
									<div class="" @keydown.enter="btnSearch()">
										<span class="title">出库时间：</span>
										<el-date-picker style="width:533px !important" v-model="searchForm.stockOutTime" type="daterange" range-separator="-"	 value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
									</div>
								</el-col>
							</el-row>
						</div>
					</el-collapse-transition>
				</el-card>
				<el-card class="table-card">
					<div class="table_common_operbar" v-if="permission.btn_stockOut_apply">
						<el-row>
							<el-button icon="el-icon-plus" type="primary" size="small" @click="addWindowShow()">新增出库</el-button>
						</el-row>
					</div>
					<el-table @sort-change='sortChangeEvent' :default-sort='defaultSort' :data="tableData" style="width: 100%" class="deviceTable y_Public_table" :row-style="showHighlight">
						<el-table-column prop="stockOutCode" label="出库单号"	min-width="120"></el-table-column>
						<el-table-column prop="stockOutType" sortable="custom" :formatter="parseStockOutType"  label='出库类型' min-width="110"></el-table-column>
						<el-table-column prop="stockOutTime" sortable="custom"  label='出库时间' min-width="110"></el-table-column>
						<el-table-column label='状态' min-width="110">
							<template slot-scope="scope">
								<span :style="{color:parseStyle(scope.row)}">{{parseStatus(scope.row)}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="applicantName" sortable="custom"  label='申请人' min-width="110"></el-table-column>
						<el-table-column prop="auditUserName" sortable="custom"  label='审核人' min-width="110"></el-table-column>
						<el-table-column sortable="custom" prop="gmtAudit" label='审核时间'  min-width="130"></el-table-column>
						<el-table-column label="操作" fixed="right" width="160">
							<template slot-scope="scope">
								<el-button v-if="permission.btn_stockOut_get" type="text" @click="showViewDialog(scope.row)" size="small">查看</el-button>
								<el-button v-if="permission.btn_stockOut_update&&scope.row.auditStatus==0" type="text"	@click="showEditPage(scope.row)" size="small">编辑</el-button>
								<el-button v-if="permission.btn_stockOut_audit&&scope.row.auditStatus==0" type="text" @click="showEditDialog(scope.row)" size="small">审核</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="page" v-if="tableData.length > 0">
						<div class="total_page"><span> 共{{tableTotalPage}}条 10条/页</span></div>
						<div style="margin-top:10px;text-align:right; margin-bottom:20px;">
							<el-pagination background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage"></el-pagination>
						</div>
					</div>
				</el-card>

				<!-- 查看出库记录开始 -->
				<el-dialog title="查看出库记录" @close="cancelViewDialog" :visible.sync="viewDialogVisible" :width="span==5?'55%':'78%'" center :close-on-click-modal="false">
					<el-table :data="stockOutDetailList" stripe style="width: 100%">
						<el-table-column prop="materialCode" label="物料编码" min-width="110"></el-table-column>
						<el-table-column prop="materialName" label="物料名称" min-width="110"></el-table-column>
						<el-table-column prop="specification" label="规格" min-width="110"></el-table-column>
						<el-table-column prop="productionBatchCode" label="批次号" min-width="110"></el-table-column>
						<el-table-column prop="warehouseName" label="仓库" min-width="110"></el-table-column>
						<el-table-column prop="factoryName" label="库位" min-width="110"></el-table-column>
						<el-table-column prop="availableAmount" label="库存数量" min-width="110"></el-table-column>
						<el-table-column prop="amount" label="出库数量" min-width="110"></el-table-column>
						<el-table-column prop="unitOfQuantity" label="出库单位" min-width="110"></el-table-column>
					</el-table>
					<el-row style="margin-top:20px;">
						<el-col :span="4">
						<div class="">
							<span class="title">申请人：</span>
							<span class="value">{{rowData.applicantName}}</span>
						</div>
						</el-col>
						<el-col :span="4" :offset="6">
						<div class="">
							<span class="title">制单人：</span>
							<span class="value">{{rowData.logInUserName}}</span>
						</div>
						</el-col>
						<el-col :span="4" :offset="6">
						<div class="">
							<span class="title">审核人：</span>
							<span class="value">{{rowData.auditUserName}}</span>
						</div>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
						<div class="">
							<span class="title">审核备注：</span>
							<span class="value">{{rowData.auditRemark}}</span>
						</div>
						</el-col>
					</el-row>
					<span slot="footer" class="dialog-footer">
						<el-button @click="printStockOutInfo(rowData)" type="primary">打 印</el-button>
						<el-button @click="cancelViewDialog" >取 消</el-button>
					</span>
				</el-dialog>
				<!-- 查看出库记录结束 -->

				<!-- 审核开始 -->
				<el-dialog title="出库审核" @close="cancelEditDialog" :visible.sync="editDialogVisible" :width="span==5?'25%':'40%'" center :close-on-click-modal="false">
					<el-row>
						<span>备注</span>
						<el-input type="textarea" v-model="editRemark" :rows="3"></el-input>
					</el-row>
					<span slot="footer" class="dialog-footer">
						<el-button @click="submitEditDialog(1)" type="primary">通 过</el-button>
						<el-button @click="submitEditDialog(2)" type="danger">不通过</el-button>
						<el-button @click="cancelEditDialog">取 消</el-button>
					</span>
				</el-dialog>
				<!-- 审核结束 -->
			</div>
		</template>
		<template v-if="showPage==2">
			<StockOutDetail/>
		</template>
		<template v-if="showPage==3">
			<StockOutEdit :selectedInfo='selectedInfo'/>
		</template>
	</div>
</template>


<script>
	import StockOutDetail from './StockOutDetail'
	import StockOutEdit from './StockOutEdit'

	export default {
		components: {
			StockOutDetail,
			StockOutEdit
		},
		name: 'RecordsOfStoreOut',
		data() {
			return {
				showMore:false,
				loading:false,
				stockOutCodeList:[],
				orderType: 'DESC',//排序类型
				orderColumn: 'gmtCreate',//排序列
				defaultSort: {prop: 'gmtCreate', order: 'descending'},//默认排序设置
				fristLoad: false,
				rowData: {},
				editRemark: null,
				selectRow: null,
				userList: [],
				stockOutTypeOption:[
					{id: 1, label: '盘点出库', value: 1},
					{id: 2, label: '销售出库', value: 2},
					{id: 3, label: '领料出库', value: 3},
					{id: 4, label: '直接出库', value: 4},
				],
				statusOption: [
					{id: 0, label: '待审核', value: 0},
					{id: 1, label: '通过审核', value: 1},
					{id: 2, label: '未通过审核', value: 2},
				],
				selectedInfo: {},
				showPage: 1,
				levelOption: [],
				checkList: [],
				unitOption: [],
				W: false,
				btnPressType: 0,//按钮类型： 0-默认 1-查询 2-重置 3-分页
				searchFormTemp: '',//临时搜索数据
				searchForm: {
					stockOutId: null,
					stockOutType: null,
					auditStatus:null,
					applicantId:null,
					stockOutTime: [],
				},
			
				viewForm: {},
				tableData: [],
				tableCurrentPage: 1,
				tableTotalPage: 2,
				addDialogVisible: false,
				editDialogVisible: false,
				viewDialogVisible: false,
				data: {
					token: localStorage.getItem("token"),
				},
				stockOutDetailList: [],
				permission: JSON.parse(localStorage.getItem("permission")),
				
			}
		},
		mounted: async function () {
			
			this.loadUlserList()
			this.initTable();
			this.loadStockOutCodeList()
			let w = document.documentElement.clientWidth || document.body.clientWidth;
			w >= 1900 ? this.W = true : this.W = false
			window.onresize = () => {
				let w = document.documentElement.clientWidth || document.body.clientWidth;
				w >= 1900 ? this.W = true : this.W = false
			}
		},
		computed: {
			span() {
				return this.W ? 5 : 6
			}
		},
		deactivated: function () {
			console.log("deactivated");
		},
		methods: {
			toggleShowMore(){
				this.showMore = ! this.showMore
			},
			async loadStockOutCodeList(stockOutCode) {
				let {data} = await this.$RequestUtil.getAsync({ url: '/api/select/stockOutCodeSelect',  params: { stockOutCode }, })
				this.stockOutCodeList = data
			},

			async remoteMethod(query){
				this.loading = true
				await this.loadStockOutCodeList(query)
				this.loading = false
			},

			async closeSelect(ev){
				if(!ev){
					await this.loadStockOutCodeList()
				}
			},

			showHighlight(scope) {
				if (scope.row.hasDeletedUser == 1) {
					return {background: '#FFFFCC'}
				}
			},

			sortChangeEvent(param) {
				let orderType = param.order;
				let orderColumn = param.prop;
				this.orderColumn = orderColumn;
				if (orderType == 'descending') {
					this.orderType = 'DESC';
				} else if (orderType == 'ascending') {
					this.orderType = 'ASC';
				} else {
					this.orderType = orderType;
					this.orderColumn = null
				}
				this.search(1);
				this.tableCurrentPage = 1
			},

			async reload() {
				this.loadUlserList()
				this.initTable();
			},

			loadUlserList() {
				this.$RequestUtil.get({
					url: '/api/select/listWorker',
					params: {noFilterDeparture: 1},
					type: 'sync',
					success: (res) => {
						if (res.code == 0) {
							this.userList = res.data;
							log(this.applicantList)
						}
					}
				});
			},

			async showEditPage(rowData) {
				let data = await this.loadStockOutDetail(rowData.stockOutId)
				this.selectedInfo = {
					stockOutId: rowData.stockOutId,
					stockOutType:rowData.stockOutType,
					stockOutTime:rowData.stockOutTime,
					applicantId:rowData.applicantId,
					data
				}
				this.showPage = 3
			},

			async loadStockOutDetail(stockOutId) {
				let {data,code,msg,message} = await this.$RequestUtil.getAsync({url: '/api/stock/stockOut/getDetail', type: 'sync', params: {stockOutId},})
				return data
			},

			cancelEditDialog() {
				this.editDialogVisible = false
				this.editRemark = null
			},

			cancelViewDialog() {
				this.viewDialogVisible = false
				this.rowData = {}
			},

			printStockOutInfo(rowData){
				let StockOutInfo = {
					applicantName:rowData.applicantName,
					logInUserName:rowData.logInUserName,
					auditUserName:rowData.auditUserName,
					auditRemark:rowData.auditRemark,
					stockOutDetailList:this.stockOutDetailList
				}
				localStorage.setItem('printStockType',1)
				localStorage.setItem('printStockInfo',JSON.stringify(StockOutInfo))
				let routeUrl = this.$router.resolve({path: "/Print/PrintStock"});
				window.open(routeUrl.href, '_blank');
			},

		
			

			submitEditDialog(type) {
				this.$RequestUtil.post({
					url: '/api/stock/handleApplication/stockOut',
					type: 'sync',
					params: {
						stockOutId: this.selectRow.stockOutId,
						auditStatus: type,
						auditRemark: this.editRemark
					},
					success: (res) => {
						if (res.code == 0) {
							if (type == 1) {
								this.$message.success('审核成功')
							} else {
								this.$message.success('提交成功')
							}
							this.initTable();
							this.cancelEditDialog()
						} else {
							this.$message.error(res.message);
						}
					},
				})
			},

			btnSearch: function () {
				this.tableCurrentPage = 1;
				this.btnPressType = 1
				this.search();
			},

			clearSearch() {
				let form = this.searchForm;
				this.btnPressType = 2;
				form.auditStatus = null
				form.stockOutId = null
				form.stockOutType = null
				form.applicantId = null
				form.stockOutTime = []
			},

			search: function () {
				let temp;
				switch (this.btnPressType) {
				case 1:
					temp = commonUtils.cloneObj(this.searchForm);
					this.searchFormTemp = commonUtils.cloneObj(temp);
					break;
				case 0:
					temp = {
						stockOutId: null,
						stockOutType: null,
						auditStatus:null,
						applicantId:null,
						stockOutTime: [],
					};
					break;
				case 2:
					temp = this.searchFormTemp;
					break;
				case 3:
					temp = this.searchFormTemp;
					break;
				}
				let stockOutStartTime,stockOutEndTime;
				if(temp.stockOutTime&&temp.stockOutTime.length==2){
					stockOutStartTime = temp.stockOutTime[0]
					stockOutEndTime = temp.stockOutTime[1]
				}
				this.$RequestUtil.get({
					url: '/api/stock/listStockOut',
					type: 'sync',
					params: {
						pageNum: this.tableCurrentPage,
						pageSize: 10,
						auditStatus: temp.auditStatus,
						stockOutId: temp.stockOutId,
						stockOutType: temp.stockOutType,
						applicantId: temp.applicantId,
						stockOutStartTime,
						stockOutEndTime,
						orderType: this.orderType,
						orderColumn: this.orderColumn
					},
					success: (res) => {
						if (res.msg == this.$Global.RESPONSE.SUCCESS) {
							this.tableData = res.data;
							this.tableTotalPage = res.totalPages;
							if (res.totalPages == 0 && this.fristLoad) {
								this.$message.warning('查询不到符合条件的数据');
							}
							this.fristLoad = true
						} else {
							this.$message.error(res.message || res.msg)
						}
					}
				});
			},

			pageChange: function (targetPage) {
				this.tableCurrentPage = targetPage;
				this.btnPressType = 3;
				this.search();
			},

			initTable: function () {
				this.search();
			},

			addWindowShow: function () {
				this.showPage = 2
				// this.addDialogVisible = true;
			},

			showEditDialog: function (rowData) {
				this.selectRow = rowData
				this.editDialogVisible = true
			},

			async showViewDialog(rowData) {
				this.rowData = commonUtils.cloneObj(rowData)
				let data = await this.loadStockOutDetail(rowData.stockOutId)
				let stockList = []
            	
				data.forEach(async item=>{
					item.stockOutDetailDtos.forEach((s,i)=>{
						
						let json = {
							...s,
							materialId:item.materialId,
							materialCode:item.materialCode,
							materialName:item.materialName,
							specification:item.specification,
							unitOfQuantity: item.unitOfQuantity,
							unitTypeId:item.unitTypeId,
							availableAmount:s.availableAmount,
						}
						stockList.push(json)
					})
					
				}) 
				this.stockOutDetailList = stockList
				this.viewDialogVisible = true;
			},

			parseDate: function (rowData) {
				if (rowData.gmtCreate != null) {
					let dateString = commonUtils.timestampToDate(rowData.gmtCreate);
					return dateString;
				}
			},

			parseStyle(rowData) {
				if (rowData.auditStatus != null) {
					if (rowData.auditStatus == 1) {
						return '#2FD859'
					} else if (rowData.auditStatus == 2) {
						return 'red'
					}
				}
			},

			parseStatus(rowData) { // 0-待审核；1-审核通过；2-审核
				if (rowData.auditStatus != null) {
					if (rowData.auditStatus == 0) {
						return '待审核'
					} else if (rowData.auditStatus == 1) {
						return '通过审核'
					} else if (rowData.auditStatus == 2) {
						return '未通过审核'
					}
				}
			},


			parseStockOutType(rowData) {
				return	(this.stockOutTypeOption.find(item=>item.id==rowData.stockOutType)||{}).label
			}
		}
	}
</script>

<style scoped>

	.table_searchbar .title11 {
		color: #606266;
		font-family: NotoSansHans-Regula;
		font-size: 14px;
	}

	.add_form .title {
		color: #606266;
		font-family: NotoSansHans-Regula;
		font-size: 14px;
		display: inline-block;
		text-align: right;
		width: 70px;
	}

	.add_form .value {
		display: inline-block
	}

	.el-row {
		margin-bottom: 20px;
		&:last-child {
			margin-bottom: 0;
		}
	}



	.import_upload {
		display: inline;
	}

	.page {
		display: flex;
		justify-content: flex-end;
	}

	@media screen and (max-width: 1450px) {
		.page {
		display: flex;
		justify-content: flex-end;
		margin-bottom: 30px;
		}
	}

	.total_page {
		margin-top: 20px;
		margin-right: 26px;
		color: #606266;
		font-size: 14px;
	}
	</style>
	<style>
	.table_searchbar .el-button--mini, .el-button--mini.is-round {
		padding: 7px 10px;
	}

	@media screen and (max-width: 1366px) {
		#store-out .el-date-editor.el-input, #store-out .el-date-editor.el-input__inner {
			width: 176px !important;
		}
	}
</style>




// WEBPACK FOOTER //
// src/views/stock/RecordsOfStoreOut.vue